<template>
  <router-link :to="{ name: subjectLink, params: { id: subject.slug }}" class="text-dark">
    <div class="bg-light-blue d-flex align-items-end" style="min-height: 260px;background: #EEF4FF url(/static/images/subjects/placeholder.svg) no-repeat center right;background-size: 35%;">
      <div class="subject-top" v-if="isPurchased">
        <div class="d-flex align-items-center">
          <!-- <vc-donut :sections="sections" :size="50" :thickness="20" background="#EEF4FF" class="justify-content-start"><h5 style="margin: 0;">67</h5></vc-donut> -->
          <div class="fz-sm">
            <p class="text-uppercase mb-0"><strong>Изучаю</strong></p>
            <!-- <p class="mb-0">Средняя оценка – 4,7</p> -->
          </div>
        </div>
      </div>
      <div class="p-3">
        <h2>{{ subject.title }}</h2>
        <p class="mb-0">{{ subject.shortDescription }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    subject: Object,
    isPurchased: Boolean
  },
  data () {
    return {
      sections: [
        { label: 'Red section', value: 75, color: '#0E245A' },
        { label: 'Green section', value: 25, color: '#CEDAF0' }
      ]
    }
  },
  computed: {
    subjectLink () {
      if (this.isPurchased) {
        return 'purchased-subject'
      } else {
        return 'subject'
      }
    }
  }
}
</script>